import * as React from 'react';

class AuthFooter extends React.Component<{}, {}> {

  render() {
    return (
      <div className="row mt3">
        <div className="col">
          <p className="f6 lh-copy ma0 white">
            &copy; {(new Date()).getFullYear()} Mimosa Solutions
            </p>
        </div>
      </div>
    );
  }
}

export default AuthFooter;


// WEBPACK FOOTER //
// ./src/auth/auth-footer.component.tsx